import type {
  AudioComponentData,
  FileComponentData,
  ImageComponentData,
  // MediaUploadError,
  VideoComponentData,
} from './../../ricos-content';
import type { UploadedData, UploadFn } from './../../ricos-types';

export const upload = (
  uploadFunc: UploadFn,
  file: File
): Promise<{
  data:
    | ImageComponentData
    | VideoComponentData
    | FileComponentData
    | AudioComponentData
    | undefined;
}> => {
  return new Promise((resolve, reject) => {
    uploadFunc(file, ({ data, error }: UploadedData) => {
      if (error) {
        reject(error);
      } else {
        resolve({ data });
      }
    });
  });
};
